exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-54d0d794] .el-table th>.cell{font-weight:700}.el-tabs__content[data-v-54d0d794]{padding-left:10px}", ""]);

// exports
